import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireLib } from '../node_modules/qs/lib/index.js';

var libExports = /*@__PURE__*/ requireLib();
var qs = /*@__PURE__*/getDefaultExportFromCjs(libExports);

export { qs as default };
